/* eslint-disable max-len */

import DgbQuestion from 'images/coin-pages/questions/dgb.svg'

import { slides } from 'pages/home/components/swiper-component/assets/slides'

import { ICoinPageData } from '../types'

export const dgbPage: ICoinPageData = {
  title: 'coin_274',
  description: 'coin_275',
  metaDescription: 'coin_dgb_meta_desc',
  metaTitle: 'coin_dgb_meta_title',
  questionsBlock: {
    image: DgbQuestion,
    questions: [
      {
        title: 'coin_277',
        answer: 'coin_278',
      },
      {
        title: 'coin_279',
        answer: 'coin_280',
      },
      {
        title: 'coin_281',
        answer: 'coin_282',
      },
      {
        title: 'coin_283',
        answer: 'coin_284',
      },
    ],
  },
  whatIs: {
    slides: slides,
    text: [],
    paragraphs: [
      {
        title: 'coin_289',
        text: ['coin_292'],
      },
      {
        title: 'coin_290',
        text: ['coin_296'],
      },
    ],
  },
  howLend: {
    title: 'coin_dgb_lend_title',
    steps: {
      calculate: {
        text: 'coin_dgb_calculate_text'
      },
      get_loan: {
        text: 'coin_dgb_get_loan_text'
      },
      start_spending: {
        text: 'coin_dgb_spending_text',
      },
      get_back: {
        title: 'coin_dgb_get_back_title',
        text: 'coin_dgb_get_back_text',
      }
    }
  }
}
